
export const API_GATEWAY = "https://api.branchof.art/api/";
export const API_GATEWAY_NOSLASH = "https://api.branchof.art/api";
export const API_UPLOAD_URL = "https://upload-media.branchof.art";
export const SITE_URL = "https://branchof.art";